import type { IFilterPanelBaseFilterDeps, IFilterPanelBaseFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { AppsIosCategoryDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsIosCategoryFilter } from "app/pages/sales-intelligence/store/find-apps/types";

export default class FindAppsCategoryFilter
    extends FilterPanelBaseFilter<IAppsIosCategoryFilter, AppsIosCategoryDescriptionDto>
    implements IFilterPanelBaseFilterModel<IAppsIosCategoryFilter, AppsIosCategoryDescriptionDto>
{
    constructor(deps: IFilterPanelBaseFilterDeps<IAppsIosCategoryFilter, AppsIosCategoryDescriptionDto>) {
        super(deps);
    }

    isFilterDirty(currentValue: IAppsIosCategoryFilter | undefined): boolean {
        return Boolean(currentValue?.values && currentValue?.values.length > 0);
    }
}
